(()=>{
  const page=document.querySelector('[data-free-gift-page]');
  if(!page)return;
  const root=()=>window.Shopify?.routes?.root||'/';
  const threshold=Math.max(0,Number(page.dataset.threshold)||0);
  const eligible=page.dataset.eligible==='true';
  const mapElement=page.querySelector('[data-free-gift-redemption-map]');
  let redemptionMap={};
  let busy=false;
  let lastFilterTrigger=null;

  if(mapElement){
    try{
      redemptionMap=JSON.parse(mapElement.textContent||'{}');
    }catch(error){
      console.error('Unable to read the free gift redemption map.',error);
    }
  }

  page.querySelectorAll('[data-free-gift-select]').forEach(button=>{
    const sourceVariantId=button.dataset.sourceVariantId;
    if(!sourceVariantId||!redemptionMap[String(sourceVariantId)]){
      button.disabled=true;
      button.textContent='Temporarily unavailable';
      button.setAttribute('aria-disabled','true');
    }
  });

  if(!eligible&&!window.Shopify?.designMode){
    window.location.replace(root()+'cart?gift=locked#free-gift');
    return;
  }

  const filterDrawer=()=>page.querySelector('[data-filter-drawer]');

  function setBodyLock(locked){
    document.documentElement.style.overflow=locked?'hidden':'';
    document.body.style.overflow=locked?'hidden':'';
  }

  function openFilters(button){
    const drawer=filterDrawer();
    if(!drawer)return;
    lastFilterTrigger=button||document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    button?.setAttribute('aria-expanded','true');
    setBodyLock(true);
    requestAnimationFrame(()=>drawer.querySelector('.collection-filter-drawer__close')?.focus());
  }

  function closeFilters({restoreFocus=true}={}){
    const drawer=filterDrawer();
    if(!drawer)return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    page.querySelector('[data-filter-drawer-open]')?.setAttribute('aria-expanded','false');
    setBodyLock(false);
    if(restoreFocus&&lastFilterTrigger&&document.contains(lastFilterTrigger))lastFilterTrigger.focus();
  }

  function focusables(panel){
    return [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(element=>!element.hasAttribute('hidden'));
  }

  function toggleFilterValues(button){
    const listId=button.getAttribute('aria-controls');
    const list=listId?document.getElementById(listId):null;
    if(!list)return;
    const expanded=button.getAttribute('aria-expanded')==='true';
    list.querySelectorAll('[data-filter-extra]').forEach(item=>{
      if(expanded&&!item.querySelector('input:checked'))item.hidden=true;
      else item.hidden=false;
    });
    button.setAttribute('aria-expanded',expanded?'false':'true');
    const label=button.querySelector('[data-filter-toggle-label]');
    if(label)label.textContent=expanded?'Show more':'Show less';
  }

  async function getCart(){
    const response=await fetch(root()+'cart.js',{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Unable to read your cart.');
    return response.json();
  }

  function qualifyingTotal(cart){
    const giftValue=(cart.items||[]).reduce((total,item)=>item.properties?._elc_free_gift==='true'?total+(Number(item.final_line_price)||0):total,0);
    return Math.max(0,(Number(cart.total_price)||0)-giftValue);
  }

  async function replaceGift(sourceVariantId,title,image,url,button){
    if(busy)return;
    const redemptionVariantId=redemptionMap[String(sourceVariantId)];
    if(!redemptionVariantId){
      window.alert('This gift is temporarily unavailable. Please choose another gift.');
      return;
    }

    busy=true;
    const original=button.textContent;
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent='Selecting…';

    try{
      let cart=await getCart();
      if(threshold<=0||qualifyingTotal(cart)<threshold)throw new Error('Your cart no longer qualifies for a free gift.');

      const existing=(cart.items||[]).filter(item=>item.properties?._elc_free_gift==='true');
      if(existing.length){
        const updates={};
        existing.forEach(item=>{updates[item.key]=0;});
        const removeResponse=await fetch(root()+'cart/update.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})
        });
        if(!removeResponse.ok)throw new Error('Unable to replace your current gift.');
      }

      const properties={
        _elc_free_gift:'true',
        _elc_source_variant_id:String(sourceVariantId),
        'Gift selection':title||'Free gift'
      };
      if(image)properties._elc_gift_image=image;
      if(url)properties._elc_gift_url=url;

      const addResponse=await fetch(root()+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(redemptionVariantId),quantity:1,properties}]})
      });
      const data=await addResponse.json();
      if(!addResponse.ok)throw new Error(data.description||data.message||'Unable to add this gift.');

      button.textContent='Gift selected';
      window.location.assign(root()+'cart#free-gift');
    }catch(error){
      window.alert(error instanceof Error?error.message:'Unable to select this gift. Please try again.');
      button.disabled=false;
      button.removeAttribute('aria-busy');
      button.textContent=original;
    }finally{
      busy=false;
    }
  }

  page.addEventListener('click',event=>{
    const filterToggle=event.target.closest('[data-filter-values-toggle]');
    if(filterToggle){
      event.preventDefault();
      toggleFilterValues(filterToggle);
      return;
    }

    const opener=event.target.closest('[data-filter-drawer-open]');
    if(opener){
      event.preventDefault();
      openFilters(opener);
      return;
    }

    const closer=event.target.closest('[data-filter-drawer-close]');
    if(closer){
      event.preventDefault();
      closeFilters();
      return;
    }

    const button=event.target.closest('[data-free-gift-select]');
    if(!button)return;
    event.preventDefault();
    const sourceVariantId=button.dataset.sourceVariantId;
    if(!sourceVariantId)return;
    replaceGift(
      sourceVariantId,
      button.dataset.productTitle||'Free gift',
      button.dataset.productImage||'',
      button.dataset.productUrl||'',
      button
    );
  });

  page.addEventListener('keydown',event=>{
    const drawer=filterDrawer();
    if(!drawer?.classList.contains('is-open'))return;
    if(event.key==='Escape'){
      event.preventDefault();
      closeFilters();
      return;
    }
    if(event.key!=='Tab')return;
    const panel=drawer.querySelector('.collection-filter-drawer__panel');
    const items=panel?focusables(panel):[];
    if(!items.length)return;
    const first=items[0];
    const last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){
      event.preventDefault();
      last.focus();
    }else if(!event.shiftKey&&document.activeElement===last){
      event.preventDefault();
      first.focus();
    }
  });
})();
